export interface SummaryItem {
  label: string;
  value: any;
  textRight?: boolean;
  cssClass?: string;
}
